import { ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig, withInMemoryScrolling } from '@angular/router';
import { environment } from '@env/environment';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withXsrfConfiguration,
} from '@angular/common/http';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { encryptionInterceptor } from './core/interceptors/encryption.interceptor';
import { BehaviorSubject } from 'rxjs';
import {
  BASE_ORG_TOKEN,
  SELECTED_ORG_TOKEN,
  SELECTED_BRANCH_TOKEN,
} from './core/tokens/selected-org.token';
import { Organization } from './core/models/organization.model';
import { baseTenantInterceptor } from './core/interceptors/base-tenant.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Branch } from '@core/models/branch.model';
import { branchInterceptor } from '@core/interceptors/branch.interceptor';
import { platformInterceptor } from './core/interceptors/platform.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, 
      withRouterConfig({
        paramsInheritanceStrategy: 'always'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      })
    ),
    provideHttpClient(
      withFetch(),
      withXsrfConfiguration({
        cookieName: environment.tokenName,
        headerName: 'X-CSRF-TOKEN',
      }),
      withInterceptors([
        platformInterceptor,
        authInterceptor,
        encryptionInterceptor,
        tenantInterceptor,
        branchInterceptor,
        baseTenantInterceptor,
      ]),
    ),
    provideAnimations(),
    {
      provide: SELECTED_ORG_TOKEN,
      useValue: new BehaviorSubject<Organization | null>(null),
    },
    {
      provide: BASE_ORG_TOKEN,
      useValue: new BehaviorSubject<Organization | null>(null),
    },
    {
      provide: SELECTED_BRANCH_TOKEN,
      useValue: new BehaviorSubject<Branch | null>(null),
    },
  ],
};
